<template>
  <div class="myWordCloud">
    <wordcloud
      :data="defaultWords"
      nameKey="name"
      valueKey="value"
      :color="myColors"
      :showTooltip="false"
      :rotate="{ from: 0, to: 0, numOfOrientation: 5 }"
      :margin="{ top: 5, right: 5, bottom: 5, left: 5 }"
      :fontSize="[20, 80]"
    />
  </div>
</template>
<style scoped>
.myWordCloud {
  width: 100%;
  height: 100%;
}

.myWordCloud div {
  height: 100%;
}

@media only screen and (max-width: 500px) {
  .myWordCloud div {
    height: 650px;
  }
}

@media only screen and (min-width: 501px) and (max-width: 800px) {
  .myWordCloud div {
    height: 450px;
  }
}

@media only screen and (min-width: 801px) {
  .myWordCloud div {
    height: 350px;
  }
}
</style>

<script>
import wordcloud from "vue-wordcloud";

const names = [
  "Benjamin Stein",
  "Johannes Koppenhöfer",
  "Corina Theurich",
  "Joachim Schittenhelm",
  "Carsten Bartelt",
  "Sergiu Gavrila",
  "Matthäus Mayer",
  "Simone Liegl",
  "Lukas Kaisers",
  "Michael Kaulig",
  "Annegret Widmer",
  "Jakob Nohe",
  "Patricia Roth",
  "Dominique Sommer",
  "Lukas Sailer",
  "Patrick Steinmetz",
  "Marius Wesseler",
  "Susanne Weller",
  "Maximilian Marschall",
  "Matthias Muth",
  "Konstantin Grupp"
].map(name => ({
  name,
  value: 20
}));

export default {
  name: "people",
  components: {
    wordcloud
  },
  data() {
    return {
      myColors: ["#000000", "#a71417"],
      defaultWords: names
    };
  },
  methods: {
    theFormat(number) {
      return (2020 - number).toFixed(0);
    },
    completed() {
      this.scaleClass = true;
    }
  }
};
</script>
